import { render, staticRenderFns } from "./FundOverviewPage.vue?vue&type=template&id=8d959024"
import script from "./FundOverviewPage.vue?vue&type=script&lang=ts"
export * from "./FundOverviewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports